import { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  TextField,
  Button,
  IconButton,
  CircularProgress,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import {
  getOtherFeeTypes,
  postOtherFeeTypes,
} from '../../features/payments/PaymentSlice';
import ToastNotification from '../UIElements/ToastNotification';
import useNotification from '../../hooks/useNotification';
import { showAlert } from '../UIElements/AlertService';

function feeNames() {
  const [initalFees, setInitialFees] = useState([]);
  const [fees, setFees] = useState([{ feeName: '' }]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [indexError, setIndexError] = useState([]);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  const dispatch = useDispatch();

  // 🔹 Handle change
  const handleChange = (index, value) => {
    const updated = [...fees];
    updated[index].feeName = value;
    setFees(updated);
  };

  // 🔹 Add new field
  const handleAdd = () => {
    setFees([...fees, { feeName: '' }]);
  };

  // 🔹 Delete field
  const handleDelete = (index) => {
    const updated = fees.filter((_, i) => i !== index);
    setFees(updated);
  };

  // 🔹 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (initalFees.length > 0 || fees.length > 0) {
      // manual trim validation
      const values = fees.map((f) => f.feeName);
      if (values.length !== new Set(values).size) {
        setIndexError('error');
        return;
      }
      try {
        setSubmitting(true);
        const response = await dispatch(postOtherFeeTypes(fees)).unwrap();
        if (response.status == 200) {
          showSuccess('Fee Types saved successfully.');
          setFees(response.data);
          //setInitialFees(response.data)
        }
      } catch (err) {
        console.error(err);
        if (err.status == 409) {
          showError("Fee Type can't be deleted as it mapped to students");
        } else showError('Error in submitting the details.');
        setFees(initalFees);
      } finally {
        setSubmitting(false);
      }
    } else {
      showAlert('Please add the Fee Types');
    }
  };
  // 🔹 Load from backend
  useEffect(() => {
    fetchFees();
  }, []);

  const fetchFees = async () => {
    try {
      setLoading(true);
      const res = await dispatch(getOtherFeeTypes()).unwrap();
      setInitialFees(res.data);
      setFees(res.data); // expecting [{ feeName: "Tuition" }]
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className='max-w-3xl px-6 py-8'>
      <Typography variant='h6' color='primary' className='mb-6'>
        Configure the Different Types of Fees
      </Typography>
      <div className='relative min-h-80 w-full '>
        {loading ? (
          <div className='absolute  size-full'>
            <div className='flex flex-col items-center gap-2 text-center sticky top-1/2'>
              <CircularProgress color='primary' />
              <div className='text-center '>Fetching feeNames Details...</div>
            </div>
            <br />
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className='space-y-4'>
              {fees.map((fee, index) => (
                <div key={index} className='flex gap-2 items-center'>
                  <TextField
                    size='small'
                    label={`Fee Type ${index + 1}`}
                    fullWidth
                    value={fee.feeName}
                    required
                    onChange={(e) => handleChange(index, e.target.value)}
                    inputProps={{ pattern: '.*\\S.*' }} // prevent only spaces
                    // error={indexError.includes(index)}
                    // helperText={
                    //   indexError.includes(index)
                    //     ? 'Fee type must not  be same'
                    //     : ''
                    // }
                  />

                  <IconButton color='error' onClick={() => handleDelete(index)}>
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))}
            </div>

            {indexError === 'error' && (
              <p className='text-red-600 mt-4'>
                <b>Note:</b> Names must be unique.
              </p>
            )}
            <div className='flex gap-4 mt-6'>
              <Button
                type='button'
                disabled={submitting}
                variant='outlined'
                onClick={handleAdd}
              >
                Add Fee Type
              </Button>
              <Button type='submit' variant='contained' disabled={submitting}>
                Submit
              </Button>
            </div>
          </form>
        )}
      </div>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </Card>
  );
}

export default feeNames;
